import { render, staticRenderFns } from "./ClubServiceDiscountControl.vue?vue&type=template&id=65a99b89&"
import script from "./ClubServiceDiscountControl.vue?vue&type=script&lang=js&"
export * from "./ClubServiceDiscountControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a99b89')) {
      api.createRecord('65a99b89', component.options)
    } else {
      api.reload('65a99b89', component.options)
    }
    module.hot.accept("./ClubServiceDiscountControl.vue?vue&type=template&id=65a99b89&", function () {
      api.rerender('65a99b89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/core/ClubServiceDiscountControl/ClubServiceDiscountControl.vue"
export default component.exports